import { graphql, useStaticQuery } from 'gatsby';

import type { Lucid } from 'types/types';

type UseBlogNewsletter = {
  directus: {
    newsletter: {
      translations: {
        id: string;
        languages_code: {
          short_code: Lucid.I18n.LanguagesShortCode;
        };
        path: {
          url: string;
        };
      }[];
    };
  };
  i18nData: Lucid.I18n.DataEdges;
};

const useBlogNewsletter = () => {
  const {
    directus: { newsletter },
    i18nData,
  } = useStaticQuery<UseBlogNewsletter>(graphql`
    query BlogNewsletterQuery {
      directus {
        newsletter: contact_form_by_id(id: "4") {
          translations {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
      }
      i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
        edges {
          node {
            name
            childSrcJson {
              mktg_newsletter_cta
              mktg_newsletter_cta_2
              mktg_newsletter_subscribe
              mktg_blog_cta_lucidchart_intro
              mktg_blog_cta_lucidspark_intro
              mktg_nav_sign_up_free
              mktg_sso_or_continue_with
              mktg_ct_all_sign_up_free
              mktg_sso_sign_in
              mktg_sso_terms
              mktg_sso_sign_in_product
            }
          }
        }
      }
    }
  `);

  return {
    newsletter,
    newsletterI18nData: i18nData,
  };
};

export default useBlogNewsletter;
